import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from './bars/PageHeader';

export const AboutPurrser = () => {
  return (
    <>
      <PageHeader header={'About Purrser'} />
      <Container className="main-container">
        <Row className="justify-content-center">
          <Col xl={8} xxl={6}>
            <div className="container-wrapper">
              <Container className="mt-3">
                <Row>
                  <Col>
                    <h2>What is Purrser?</h2>
                    <h3 className="banner">Introduction to Purrser</h3>
                    <p>
                      Purrser is an organizer of all your Algorand accounts and serves as a global
                      wallet to all of them. As you collect NFTs and various other assets, your
                      accounts tend to get chaotic and disorganized.
                    </p>
                    <h3 className="banner">Mission Statement</h3>
                    <p>
                      As your accounts get disorganized as you mint, transfer, and buy
                      assets/NFTs/etc., Purrser serves to provide an easy-to-use interface for
                      managing them.
                    </p>
                    <h3 className="banner">What is Purrser solving?</h3>
                    <h4 className="sub-header-text header-modal">
                      Problem #1: Assets cannot be grouped
                    </h4>
                    <p>
                      There is no current way to group assets within a single account. It's natural
                      to want to organize your assets based on whether they are:
                    </p>
                    <ul>
                      <li>NFTs</li>
                      <li>Collections and types of NFTs</li>
                      <li>Tokenized assets</li>
                      <li>Tokens (YLDY, SMILE, etc.)</li>
                    </ul>
                    <p>
                      The natural way to solve this is to simply use each account/wallet as an
                      organized vehicle for your assets. Wallets are free to generate as your
                      collections grow.
                    </p>
                    <h4 className="sub-header-text header-modal">
                      Problem #2: Moving multiple assets is time consuming
                    </h4>
                    <p>
                      This app will provide an easy-to-use management interface for all of their
                      accounts. For example, if you wanted to transfer a wallet with 10+ assets to a
                      brand new wallet, you'd have to opt in on receiving wallet for each asset
                      one-by-one, and then send each asset one-by-one. And if you wanted to opt out
                      of those assets to lower your min balance or clean up your wallet, then you'd
                      have to do an opt out transaction one-by-one again... Not to mention, you need
                      to sign for every single transaction! The secret sauce here is you will be
                      able to drag and drop your assets into new wallet, review transaction log,
                      then hit a single button!
                    </p>
                    <h4 className="sub-header-text header-modal">
                      Problem #3: Your accounts can be spread across multiple wallet services
                    </h4>
                    <p>
                      Many Algorand users will utilize multiple services like MyAlgo, AlgoSigner, or
                      Pera Wallet. Purrser can help you manage all of them and their assets within
                      one interface... or feel free to just make Purrser wallets which unlocks more
                      features within Purrser!
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="container-wrapper">
              <Container className="mt-3">
                <Row>
                  <Col>
                    <h2>How Purrser Works</h2>
                    <h3 className="banner">Core functionality</h3>
                    <p />
                    <h4 className="sub-header-text header-modal">Main features of Purrser are:</h4>
                    <ul>
                      <li>
                        Access all of your Algorand accounts from MyAlgo, AlgoSigner, and Pera
                        Wallet
                      </li>
                      <li>Create or import accounts directly into Purrser</li>
                      <li>View assets and balances of each connected account</li>
                      <li>Opt into new assets</li>
                      <li>Swap assets through drag and drop functionality</li>
                      <li>View pending transaction log</li>
                      <li>Submit any type of transaction from any wallet</li>
                    </ul>
                    <p />
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="container-wrapper">
              <Container className="mt-3">
                <Row>
                  <Col>
                    <h2>Future of Purrser</h2>
                    <h3 className="banner">Roadmap</h3>
                    <p>
                      This is a work in progress and is currently in testnet. However there are some
                      planned features in the future.
                    </p>
                    <ul>
                      <li>NFT viewer</li>
                      <li>Asset minter</li>
                      <li>Multiple select drag and drop</li>
                      <li>Partial amount asset swapping/transfers</li>
                      <li>and various other quality of life features</li>
                    </ul>
                    <p>
                      Stretch goal of Purrser is to make a mobile app version. For now you can use
                      the internet browser app on your mobile device.
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="container-wrapper">
              <Container className="mt-3">
                <Row>
                  <Col>
                    <h2>Contact Us</h2>
                    <p>If you have any questions or feedback, you can always contact us.</p>
                    <ul>
                      <li>
                        <a
                          href="http://www.purrser.com/contact"
                          rel="external nofollow noopener noreferrer"
                          target="_blank"
                        >
                          http://www.purrser.com/contact
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
        <div style={{ height: '2rem' }}></div>
      </Container>
    </>
  );
};

export default AboutPurrser;
